<template>
    <div>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="loadData"
        >
            <van-cell v-for="(item,index) in list" :key="index">
                <!-- 使用 title 插槽来自定义标题 -->
                <template>
                    <div class="flex">
                        <div class="flex flex-sub align-center justify-between">
                            <div>
                                <span class="label">游戏:</span>
                                <span>{{ item.gameName }}</span>
                            </div>
                            <div style="min-width: 35%">
                                <div class="flex justify-between">
                                    <span class="label">可接段位:</span>
                                    <div class="flex align-center"
                                         @click="openPicker(item.gameCategoryId,'game')">
                                        <span>{{ item.gameRankId ? rankNameMap[item.gameRankId] : '未设置' }}</span>
                                        <van-icon name="arrow-down"/>
                                    </div>
                                </div>
                                <div class="flex justify-between">
                                    <span class="label">包C段位:</span>
                                    <div class="flex align-center"
                                         @click="openPicker(item.gameCategoryId,'carry')">
                                            <span>{{
                                                item.carryRankId ? rankNameMap[item.carryRankId] : '未设置'
                                                }}</span>
                                        <van-icon name="arrow-down"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </van-cell>
        </van-list>
        <van-popup v-model="pickerVisible" position="bottom" round>
            <van-picker
                    :columns="pickerColumns"
                    show-toolbar
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
            />
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    Button,
    Cell,
    CellGroup,
    DropdownItem,
    DropdownMenu,
    Field,
    Icon,
    List,
    Picker,
    Popup,
    Switch,
    Toast
} from 'vant';
import {handlePromise} from "@/libs/util";
import {listGameSetting, updateGameSetting} from "@/api/clerk/dispatchOrder";
import _ from 'lodash'

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(Icon)
Vue.use(List)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)

export default {
    name: "updateRank",
    data() {
        return {
            loading: false,
            finished: false,
            list: [],
            gameRankMap: {},
            rankNameMap: {},
            pickerGameId: null,
            pickerType: null,
            pickerVisible: false,
        }
    },
    computed: {
        pickerColumns() {
            if (this.pickerGameId) {
                let columns = _.map(this.gameRankMap[this.pickerGameId], (elem) => {
                    return elem.name
                })
                columns.unshift('未设置')
                return columns
            }
            return []
        }
    },
    methods: {
        loadData() {
            Toast.loading({
                mask: true,
                message: '加载中'
            })
            handlePromise(listGameSetting(), (data) => {
                Toast.clear()
                this.list = data.list
                this.gameRankMap = data.gameRankMap
                this.rankNameMap = data.rankNameMap
                this.finished = true
            })
        },
        openPicker(gameCategoryId, type) {
            this.pickerGameId = gameCategoryId
            this.pickerType = type
            this.pickerVisible = true
        },
        onPickerConfirm(val) {
            let rank = _.find(this.gameRankMap[this.pickerGameId], (elem) => {
                return elem.name === val
            })
            this.pickerVisible = false
            Toast.loading({
                mask: true,
                message: '加载中'
            })
            handlePromise(updateGameSetting(this.pickerGameId, this.pickerType, rank?rank.id:null), () => {
                Toast.clear()
                this.loadData()
            })
        },
        onPickerCancel() {
            this.pickerVisible = false
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style scoped>

</style>
